import { captureException, flush as sentryFlush,getCurrentScope } from '@sentry/nextjs';

import { isProd } from '@/utils/EnvUtils';

const FLASH_TIMEOUT = 2000;
class SentryService {
  setUser(userId: number) {
    getCurrentScope()?.setUser({ id: String(userId) });
  }

  captureException(error: Error) {
    if(!isProd) {
      console.error(error);
    }
    captureException(error);
  }

  async flush() {
    return sentryFlush(FLASH_TIMEOUT);
  }
}
const sentryService = new SentryService();
export default sentryService;
